 <template>
  <div class="map-loaction-wrapper">
    <transition name="fade">
      <div class="map-wiget">
        <gmap-autocomplete
          placeholder="Select your location"
          @place_changed="setPlace"
          class="search-input"
          :options="{ fields: ['geometry', 'formatted_address', 'name'] }"
          :value="location_name"
        ></gmap-autocomplete>
      </div>
      <!-- Location list -->
    </transition>
  </div>
</template>
<script>
export default {
  name: "map-helper",
  components: {},
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      location_list: [],
      inactive: false,
      selected_location_name: "",
      loading_location_list: false,
      show_location_list: false,
      locaction_widget: false,
      position: {
        lat: 0,
        lng: 0,
      },
      markers: [],
      place: null,
      location_name: "",
    };
  },
  mounted() {
    let vm = this;
    if (vm.value) {
      vm.location_name = vm.value;
    }
  },
  watch: {
    value(val) {
      let vm = this;
      if (val) {
        vm.location_name = val;
      }
    },
  },
  methods: {
    usePlace() {
      let vm = this;
      this.onUse(vm.selected_location_name, vm.position);
    },
    selectLocation(item) {
      let vm = this;
      vm.selected_location_name = item.formatted_address;
      vm.position = {
        lat: item.geometry.location.lat,
        lng: item.geometry.location.lng,
      };
      vm.show_location_list = false;
    },
    onUse(name, position) {
      let vm = this;
      if (vm.selected_location_name) {
        vm.$emit("onSubmit", { name: name, position: position });
        vm.$emit("input", name);
      } else {
        this.$notify({
          group: "status",
          type: "warn",
          title: "Error message",
          text: "No selected location",
        });
      }
    },
    getInfo(e) {
      let vm = this;
      vm.loading_location_list = true;
      this.position = {
        lat: e.latLng.lat(),
        lng: e.latLng.lng(),
      };
      this.show_location_list = true;
      this.axios
        .get(
          `https://maps.googleapis.com/maps/api/geocode/json?latlng=${this.position.lat},${this.position.lng}&sensor=true&key=AIzaSyC4scenSTK8lTrQMFF1GwaB9JICHEras34`
        )
        .then((response) => {
          if (response.data.status == "OK") {
            vm.location_list = response.data.results;
            vm.loading_location_list = false;
          }
        })
        .catch((error) => {
          vm.loading_location_list = false;
        });
    },
    setPlace(place) {
      let vm = this;
      if (vm.$hasKey(place, "geometry.location")) {
        vm.place = place;
        vm.selected_location_name = place.formatted_address;
        vm.position = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        vm.usePlace();
      } else {
        this.$notify({
          group: "status",
          type: "warn",
          title: "Error message",
          text: "Please select location suggetion",
        });
      }
    },
    setCurrentPosition(position) {
      this.position.lat = position.coords.latitude;
      this.position.lng = position.coords.longitude;
    },
    showError(error) {
      switch (error.code) {
        case error.PERMISSION_DENIED:
          console.log("User denied the request for Geolocation.");
          break;
        case error.POSITION_UNAVAILABLE:
          console.log("Location information is unavailable.");
          break;
        case error.TIMEOUT:
          console.log("The request to get user location timed out.");
          break;
        case error.UNKNOWN_ERROR:
          console.log("An unknown error occurred.");
          break;
      }
    },
    closeModal() {
      this.locaction_widget = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.map-loaction-wrapper {
  width: 100%;
  .map-wiget {
    width: 100%;
    .search-input {
      width: 100%;
      height: 45px;
      padding: 0px 15px;
      border-radius: 5px;
      background: #fff;
      border: 1px solid #ddd;
      outline: none;
    }
  }
}
</style>

<style lang="scss">
.pac-container {
  //z-index: 999999999999999 !important;
}

.pac-logo:after {
  display: none !important;
}

.pac-item {
  cursor: pointer;
  padding: 9px 4px !important;
}
</style>